import React from 'react';
import './CashpointsTransactionDate.less'

export const CashpointsTransactionDate = ({text}) => {
	return <span className="cashpoints-transaction-date">{text}</span>
}
